module.exports = __webpack_public_path__ + "static/media/shop.2244a25b.svg";